import { Injectable } from '@angular/core';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { moduleRoutes } from './urlmap';

import { ApplicationHttpClient } from './../http-client';
// import { Observable } from 'rxjs';

@Injectable()
export class AuthService {
  private mapRoutes = moduleRoutes;

  constructor(
    private http: ApplicationHttpClient,
  ) {}

  login(credentials): Observable<any> {
    return this.http.Post(this.mapRoutes.login, credentials);
  }

  otp(credentialsOTP): Observable<any> {
    return this.http.Post(this.mapRoutes.otp, credentialsOTP);
  }

  recoverAccount(email: string): Observable<any> {
    return this.http.Post(this.mapRoutes.recover, {email: email});
  }

  resetAccountPassword(payload): Observable<any> {
    return this.http.Post(this.mapRoutes.reset, payload);
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return 'Something bad happened; please try again later.';
  }

  registerSession(info: object) {
    return this.http.Post(this.mapRoutes.registerSession, info);
  }
}
